/* =====================================================
   NuFace 2026 Redesign — Announcement Bar JS
   MS 2026-05-19

   Lightweight rotator. No deps. One IIFE per page.
   ===================================================== */
(function () {
  'use strict';

  var roots = document.querySelectorAll('.announcement-bar-2026');
  if (!roots.length) return;

  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      document.documentElement.style.setProperty('--announcement-height', roots[0].offsetHeight + 'px');
    }).observe(roots[0]);
  }

  roots.forEach(function (root) {
    var slides = root.querySelectorAll('.announcement-bar-2026__slide');
    if (slides.length < 2) {
      if (slides[0]) slides[0].setAttribute('data-active', 'true');
      return;
    }

    var prev = root.querySelector('.announcement-bar-2026__arrow--prev');
    var next = root.querySelector('.announcement-bar-2026__arrow--next');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-autoplay-length'), 10) || 5;
    var current = 0;
    var timer = null;

    function show(i) {
      slides.forEach(function (s, idx) {
        s.setAttribute('data-active', idx === i ? 'true' : 'false');
      });
      current = i;
    }

    function go(delta) {
      var n = slides.length;
      show(((current + delta) % n + n) % n);
    }

    function start() {
      if (!autoplay || root.querySelector('.announcement-bar-2026__fine-print.is-open')) return;
      stop();
      timer = setInterval(function () { go(1); }, interval * 1000);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    if (next) next.addEventListener('click', function () { go(1);  start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(0);
    start();

    root.addEventListener('finePrint:toggle', function (event) {
      if (event.detail.open) stop(); else start();
    });
  });

  // Fine print panels: place under the "?" that opened them; pause rotation while open.
  var supportsPopover = 'popover' in HTMLElement.prototype;
  function place(panel, button) {
    var rect = button.getBoundingClientRect();
    var half = Math.min(360, window.innerWidth - 32) / 2;
    var left = Math.max(16 + half, Math.min(rect.left + rect.width / 2, window.innerWidth - 16 - half));
    panel.style.setProperty('--fine-print-top', (rect.bottom + 10) + 'px');
    panel.style.setProperty('--fine-print-left', left + 'px');
  }
  function announce(panel, open) {
    panel.classList.toggle('is-open', open);
    var root = panel.closest('.announcement-bar-2026');
    if (root) root.dispatchEvent(new CustomEvent('finePrint:toggle', { detail: { open: open } }));
  }
  document.querySelectorAll('.announcement-bar-2026__info').forEach(function (button) {
    var panel = document.getElementById(button.getAttribute('popovertarget'));
    if (!panel) return;
    if (supportsPopover) {
      panel.addEventListener('toggle', function (event) {
        var open = event.newState === 'open';
        if (open) place(panel, button);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        announce(panel, open);
      });
      window.addEventListener('scroll', function () {
        if (panel.matches(':popover-open')) panel.hidePopover();
      }, { passive: true });
    } else {
      panel.removeAttribute('popover');
      var close = function () { announce(panel, false); button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', function () {
        var open = !panel.classList.contains('is-open');
        if (open) place(panel, button);
        announce(panel, open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      panel.querySelector('.announcement-bar-2026__fine-print-close').addEventListener('click', close);
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
      document.addEventListener('click', function (event) {
        if (!panel.contains(event.target) && event.target !== button) close();
      });
    }
  });
})();
